import dynamic from 'next/dynamic';

export default dynamic(
  () => import(/* webpackChunkName: "HeadTag.components" */'./HeadTag.component'),
  { loading: () => null }
);
